export const createOrderBodyPayload = ({
  boxCondition,
  condition,
  expectedPriceCents,
  instantShip,
  productId,
  productTemplateId,
  size,
}) => {
  const payload = {
    boxCondition: boxCondition || null,
    expectedPriceCents: Number(expectedPriceCents) || null,
    instantShip: instantShip === 'true',
    productId: Number(productId) || null,
    productTemplateId: Number(productTemplateId) || null,
    shoeCondition: condition || null,
    size: size || null,
  }

  for (const key of Object.keys(payload)) {
    if (payload[key] === null) {
      delete payload[key]
    }
  }

  return { order: payload }
}
